import { render, staticRenderFns } from "./participants-number.vue?vue&type=template&id=6097a878&scoped=true&"
import script from "./participants-number.vue?vue&type=script&lang=js&"
export * from "./participants-number.vue?vue&type=script&lang=js&"
import style0 from "./participants-number.vue?vue&type=style&index=0&id=6097a878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097a878",
  null
  
)

export default component.exports